import React from "react";
import { DropdownChangeEvent } from "primereact/dropdown";
import { Container, IconWrapper, StyledDropdown } from "./CustomInput.styles";

interface Option {
  label: string;
  value: any;
  [key: string]: any;
}

interface CustomDropdownProps {
  value: any;
  onChange: (value: any) => void;
  onBlur?: () => void;
  options: Option[];
  placeholder?: string;
  icon: React.ReactNode;
  optionLabel?: string;
  optionValue?: string;
  className?: string;
  invalid?: boolean;
  filter?: boolean;
  disabled?: boolean;
}

const CustomDropdown: React.FC<CustomDropdownProps> = ({
  value,
  onChange,
  onBlur,
  options,
  placeholder,
  icon,
  optionLabel = "label",
  optionValue = "value",
  className = "",
  invalid = false,
  filter = false,
  disabled = false,
}) => {
  return (
    <Container className={className} invalid={invalid}>
      <IconWrapper>{icon}</IconWrapper>
      <StyledDropdown
        value={value}
        onChange={(e: DropdownChangeEvent) => onChange(e.value)}
        onBlur={onBlur}
        options={options}
        optionLabel={optionLabel}
        optionValue={optionValue}
        placeholder={placeholder}
        filter={filter}
        disabled={disabled}
      />
    </Container>
  );
};

export default CustomDropdown;
